import SEO from "@/components/SEO";
import PageHero from "@/components/sections/PageHero";
import CTASection from "@/components/sections/CTASection";
import { Reveal, StaggerGroup, staggerItem } from "@/components/motion/Reveal";
import { motion } from "framer-motion";
import { Eyebrow, SectionHeading } from "@/components/primitives";
import { changes, caseStudies } from "@/content/site";
import { Check } from "lucide-react";

export default function Results() {
  const hasCaseStudies = caseStudies.length > 0;

  return (
    <>
      <SEO
        title="Results & How We Measure Progress | Green Circle Group"
        description="Green Circle Group focuses on relevant visibility, qualified enquiries, response, pipeline movement and booked opportunities—not marketing activity in isolation."
        path="/results"
      />
      <PageHero
        eyebrow="Results"
        heading="Measure progress where it matters—in the business."
        copy="Green Circle Group focuses on relevant visibility, qualified enquiries, response, pipeline movement and booked opportunities—not marketing activity in isolation."
        breadcrumbs={[
          { label: "Home", to: "/" },
          { label: "Results", to: "/results" },
        ]}
      />

      {/* Case studies carousel hidden automatically when empty */}
      {hasCaseStudies ? (
        <section className="bg-soft py-20 md:py-28">
          <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
              {caseStudies.map((cs) => (
                <div
                  key={cs.id}
                  className="rounded-[1.75rem] bg-white border border-border-neutral p-8"
                >
                  <h3 className="text-xl font-extrabold text-forest">
                    {cs.trade}
                  </h3>
                  <p className="mt-2 text-mid-neutral">{cs.outcome}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : (
        <section className="bg-soft py-20 md:py-28">
          <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <Eyebrow>What changes</Eyebrow>
            <SectionHeading className="mt-5">
              What we help trade businesses change
            </SectionHeading>
            <StaggerGroup className="mt-12 grid md:grid-cols-2 gap-4">
              {changes.map((c) => (
                <motion.div
                  key={c}
                  variants={staggerItem}
                  className="flex items-start gap-4 rounded-2xl bg-white border border-border-neutral p-6"
                >
                  <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-forest text-lime">
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                  <p className="text-dark-neutral leading-relaxed">{c}</p>
                </motion.div>
              ))}
            </StaggerGroup>

            <Reveal className="mt-12 rounded-[1.5rem] bg-white border border-border-neutral p-7 text-sm text-mid-neutral max-w-3xl">
              Verified client case studies will be published here once approved.
              Green Circle Group does not publish invented results, statistics or
              testimonials. Outcomes vary according to the market, offer,
              competition, budget, capacity and client response.
            </Reveal>
          </div>
        </section>
      )}

      <CTASection />
    </>
  );
}
